import { Toaster as ToasterComponent } from "$src/core/services/alerting";

import $ from "./Toaster.styles";

const Toaster = () => (
  <ToasterComponent
    toastOptions={{
      toastContainerStyle: $.toastContainer,
      toastContentStyle: $.toastContent,
      style: $.toast,
      titleStyle: $.titleStyle,
    }}
  />
);

export default Toaster;
